import axios from 'axios';
import { toast } from 'react-toastify';

const getAuthHeader = () => {
  const tokenStr = localStorage.getItem('user');
  if (tokenStr) {
    const token = JSON.parse(tokenStr).token;
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

const API_BASE = `${process.env.REACT_APP_BACKEND_SERVER}/api/devices`;

/**
 * Export devices by type and trigger file download.
 * @param {string} deviceType - mac, iphone, ipad, appletv
 * @param {'json'|'csv'} format - Export format (default: 'json')
 * @param {{ serialNumbers?: string[] }} [options]
 */
const exportDevices = async (deviceType, format = 'json', options = {}) => {
  try {
    const serialNumbers = Array.isArray(options.serialNumbers)
      ? options.serialNumbers.map((s) => String(s).trim()).filter(Boolean)
      : undefined;

    const response = await axios.get(`${API_BASE}/${deviceType}/export`, {
      headers: getAuthHeader(),
      params: { format, ...(serialNumbers?.length ? { serialNumbers } : {}) },
      responseType: 'blob'
    });

    const filename = response.headers['content-disposition']
      ?.match(/filename="?([^"]+)"?/)?.[1]
      || `${deviceType}s-export-${new Date().toISOString().slice(0, 10)}.${format === 'json' ? 'json' : 'csv'}`;

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.success(`Export erfolgreich: ${filename}`);
  } catch (err) {
    if (err.response?.status === 401) {
      toast.error('Nicht autorisiert');
    } else if (err.response?.status === 404) {
      toast.error('API nicht gefunden');
    } else {
      toast.error('Export fehlgeschlagen');
    }
    throw err;
  }
};

const deviceExportService = { exportDevices };
export default deviceExportService;
